import * as React from "react";
import { SVGProps } from "react";
export const ThumbUpIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.0001 17.4999H4.83342V6.66658L10.6667 0.833252L11.7084 1.87492C11.8056 1.97214 11.8855 2.10409 11.948 2.27075C12.0105 2.43742 12.0417 2.59714 12.0417 2.74992V3.04159L11.1251 6.66658H16.5001C16.9445 6.66658 17.3334 6.83325 17.6667 7.16658C18.0001 7.49992 18.1667 7.88881 18.1667 8.33325V9.99992C18.1667 10.0971 18.1529 10.2013 18.1251 10.3124C18.0973 10.4235 18.0695 10.5277 18.0417 10.6249L15.5417 16.4999C15.4167 16.7777 15.2084 17.0138 14.9167 17.2083C14.6251 17.4027 14.3195 17.4999 14.0001 17.4999ZM6.50008 15.8333H14.0001L16.5001 9.99992V8.33325H9.00008L10.1251 3.74992L6.50008 7.37492V15.8333ZM4.83342 6.66658V8.33325H2.33341V15.8333H4.83342V17.4999H0.666748V6.66658H4.83342Z"
            fill="currentColor"
        />
    </svg>
);
ThumbUpIcon.displayName = "ThumbUpIcon";
